import React, { useContext } from 'react';

const RecordingContext = React.createContext(null);

export default RecordingContext;

export function useRecordingContext() {
    return useContext(RecordingContext);
}
